import { faPen, faTelescope } from '@fortawesome/pro-regular-svg-icons'

import { BasicEmptyState, CoreEmptyState, EmptyStateWithAction } from '@scoir/empty-state'
import NewContentMenuButton from '../NewContentMenuButton'

type ContentTableEmptyStateProps = {
  canManageContent?: boolean
  isFiltered?: boolean
  clearFilters?: () => void
}

const ContentTableEmptyState = ({
  canManageContent = true,
  isFiltered = false,
  clearFilters,
}: ContentTableEmptyStateProps) => {
  if (!canManageContent) {
    return (
      <BasicEmptyState
        title="You don’t have permission to add content"
        subTitle="Contact your school’s administrator to grant you the appropriate access."
        icon={faPen}
      />
    )
  }
  return isFiltered ? (
    <EmptyStateWithAction
      title="No content found"
      subTitle="Try removing some filters to expand your search"
      icon={faTelescope}
      actionProps={{
        children: 'Clear All Filters',
        onClick: clearFilters,
      }}
    />
  ) : (
    <CoreEmptyState
      title="Start standing out from the crowd"
      subTitle="Add Posts, Events, and Programs to engage Students, Parents, and Counselors. Personalize at scale with tags and cards mapped to student interests. "
      icon={faPen}
    >
      <NewContentMenuButton />
    </CoreEmptyState>
  )
}

export default ContentTableEmptyState
